<script setup lang="ts">
export interface StatisticsKpiTile {
  label: string;
  value: string;
  /** Small muted context after the value, e.g. "of 2,412". */
  suffix?: string;
}

defineProps<{ tiles: StatisticsKpiTile[] }>();
</script>

<template>
  <n-grid cols="1 s:2 m:3 l:4 xl:5" responsive="screen" :x-gap="12" :y-gap="12">
    <n-gi v-for="tile in tiles" :key="tile.label">
      <n-card size="small">
        <n-statistic :label="tile.label">
          {{ tile.value }}
          <template v-if="tile.suffix" #suffix>
            <n-text depth="3" style="font-size: 14px">{{ tile.suffix }}</n-text>
          </template>
        </n-statistic>
      </n-card>
    </n-gi>
  </n-grid>
</template>
